import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";



export function PageArray<T>(page: Observable<number>, pageSize: Observable<number>): OperatorFunction<T[], T[]> {

  return switchMap(array =>
    combineLatest(page, pageSize).pipe(
      map(([_page, _pageSize]) => {
        
        return array.slice(_page * _pageSize, (_page + 1) * _pageSize);
      })
    )
  );
}



export interface Page<T> {
  page: T[],
  totalCount: number
}
